export const ColorPalette = {
  TRANSPARENT: 'transparent',
  GREY_70: 'hsl(0, 0%, 70%)',
  DARK_BLACK: '#111111',
  BLACK: '#555555',
  LIGHT_BLACK: '#595959',
  LIGHT_GREY: '#BAC0C5',
  DARK_BLUE: '#264653',
  DARK_BLUE_2: '#1E3742',
  DARK_GREY: '#81949F',
  MID_GREY: '#E0E0DE',
  GREY_2: '#eeeeec',
  GREY: '#F6F7FB',
  WHITE: '#FFFFFF',
  // Roles
  IMPORTER: '#E76F51',
  EXPORTER: 'mediumslateblue',
  SERVICE_PROVIDER: '#E9C46A',
  IMPORTER_DARK: '#E76F51',
  EXPORTER_DARK: '#2A9D8F',
  SERVICE_PROVIDER_DARK: '#E9C46A',
  LINK: '#4fb7c3',
  BRIGHT_EXPORTER: '#84E4A8',
  YELLOW_GREEN: 'greenyellow',
  RED: '#c02f58',
  ERROR: '#e74c3c',
  ERROR_LIGHT: '#FFCCCB',
  GREEN: '#22aa99',
  PURPLE: 'mediumslateblue',
  RED_BASE: 'red',
  DARKER_BLUE: '#00293B',
  DASHBOARD_LABELS: {
    fontSize: 11,
    fontFamily: 'Poppins',
    fill: '#81949F',
  },
  STATUS_WEAK: '#fcf5c7',
  STATUS_TERRIBLE: '#F2CDC4',
  STATUS_STRONG: '#AED8F2',
  STATUS_EXCELLENT: '#d1ebd8',
  STATUS_WEAK_BORDER: '#ffecb3',
  STATUS_TERRIBLE_BORDER: '#FF756D',
  STATUS_STRONG_BORDER: '#b2ebf2',
  STATUS_EXCELLENT_BORDER: '#7bff82',
};

export const COLOR_CONFIG_DEFAULT = [
  '#E30000',
  '#01B31C',
  '#150FF0',
  '#8800BF',
  '#777777',
];

export const CARD_STATUS = [
  'Terrible',
  'Weak',
  'Normal',
  'Strong',
  'Excellent',
];

export const COLOR_CARD_STATUS = [
  ColorPalette.STATUS_TERRIBLE,
  ColorPalette.STATUS_WEAK,
  ColorPalette.WHITE,
  ColorPalette.STATUS_STRONG,
  ColorPalette.STATUS_EXCELLENT,
];

export const HSK_COLORS = {
  HSK2: '#80ffed',
  HSK3: '#f6d985',
  HSK4: '#E76F51',
  HSK5: '#c02f58',
  HSK6: '#E30000',
};
